module.exports = __webpack_public_path__ + "static/media/nov2024-2.f51edc5e.webp";